import { Typography } from '@braskai/ui-kit';

import { Box, Stack } from '@mui/material';

import { ZapOffIcon } from '@/shared/assets/icons/ZapOffIcon';

export const NoPaymentDueCard = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'grey.50',
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: '12px',
        padding: '16px',
      }}
    >
      <Stack direction="row" gap={10}>
        <ZapOffIcon height={20} width={20} />
        <Stack gap={2}>
          <Typography color="grey.900" variant="body-2-md">
            No upcoming booster charges
          </Typography>
          <Typography color="grey.700" variant="body-2">
            You won't have any active boosters after confirmation.
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
